import React, { HTMLAttributes } from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import {
  Icon, WysiwygField, isExternalLink, useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphWorkingOnNow as Type } from '../../../types/uncinc_profile/paragraphs';
import { ButtonWrapper } from '../../../components';
import { SCREEN_NORMAL } from '../../../config/constants';

import './style.scss';

interface ParagraphWorkingOnNowProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphWorkingOnNow: React.FC<ParagraphWorkingOnNowProps> = ({ entity }) => {
  const paragraphWorkingOnNow = entity.toJS();
  const title = paragraphWorkingOnNow.field_title[0]?.value;
  const body = paragraphWorkingOnNow.field_body[0]?.value;
  const link = paragraphWorkingOnNow.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;

  const items = paragraphWorkingOnNow.field_paragraphs;

  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_NORMAL;

  return (
    <div className="Paragraph">
      <div className="ParagraphWorkingOnNow row">
        <div className="ParagraphWorkingOnNow__body col-12 col-md-5">
          <h2>{title}</h2>
          <WysiwygField
            className="text--large"
            html={body}
          />
          {(!isMobile && linkUrl) && (
            <ButtonWrapper
              href={linkUrl}
            >
              {linkTitle}
            </ButtonWrapper>
          )}
        </div>

        <div className="ParagraphWorkingOnNow__links col-12 col-md-6 offset-md-1">
          <ul className="ParagraphWorkingOnNow__links__items">
            {items.map((item) => {
              const itemTitle = item.entity.field_title[0].value;
              const itemBody = item.entity.field_label[0].value;
              const itemLinkUrl =
                item.entity.field_link?.[0]?.alias || item.entity.field_link?.[0]?.uri;
              const itemLinkTitle = item.entity.field_link?.[0]?.title;
              const icon = !isExternalLink(itemLinkUrl) ? 'arrow_forward' : 'north_east';

              return (
                <li className="ParagraphWorkingOnNow__links__items__item">
                  <h3>{itemTitle}</h3>
                  <p>{itemBody}</p>
                  {itemLinkUrl && (
                    <CoreLink className="link--text" href={itemLinkUrl}>
                      {itemLinkTitle}
                      <Icon name={icon} />
                    </CoreLink>
                  )}
                </li>
              );
            })}
          </ul>
          {(isMobile && linkUrl) && (
            <ButtonWrapper
              href={linkUrl}
            >
              {linkTitle}
            </ButtonWrapper>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParagraphWorkingOnNow;
